import Button from "@/components/Button";
import Dialog from "@/components/Dialog";

type DiscardBeneficiariesChangesDialogProps = {
  open: boolean;
  onDismiss: () => void;
  onDiscard: () => void;
};

export default function DiscardBeneficiariesChangesDialog({
  open,
  onDismiss,
  onDiscard
}: DiscardBeneficiariesChangesDialogProps) {
  return (
    <Dialog
      open={open}
      onClosed={onDismiss}
      headline="Discard Changes"
      className="sm:max-w-[423px] p-6 pr-2"
      actions={
        <>
          <Button variant="text" onClick={onDismiss} testId="keep-editing-beneficiaries">
            Keep Editing
          </Button>
          <Button variant="filled" onClick={onDiscard} testId="discard-beneficiaries-changes">
            Discard Changes
          </Button>
        </>
      }
    >
      <p>Do you want to discard your changes to these beneficiaries? This cannot be undone.</p>
    </Dialog>
  );
}
